import { styled, SxProps, Theme } from '@mui/material';
import { vendorLinkColor } from '@/pages/Candidate/view/oneOffOrder/rowLink';

export const DatagridSx: SxProps<Theme> = (theme) => {
  // One step off the row so the nested fields read as their own block.
  const expandBackground = theme.palette.mode === 'dark' ? '#2e2f46' : '#f7f7f9';
  return {
    '& .MuiTableRow-root.RaDatagrid-expandedPanel:hover, & .MuiTableRow-root.RaDatagrid-expandedPanel': {
      backgroundColor: `${expandBackground} !important`,
    },
    '& .RaDatagrid-expandedPanel .MuiTableCell-root': {
      backgroundColor: `${expandBackground} !important`,
    },
    '& .RaDatagrid-expandHeader, & .RaDatagrid-expandIconCell': {
      position: 'relative',
      width: 36,
      padding: 0,
    },
    '& .MuiIconButton-root.RaDatagrid-expandIcon': {
      position: 'absolute',
      inset: 0,
      width: '100%',
      height: '100%',
      borderRadius: 0,
      // The grid rotates this whole button. On a full-height cell that swings it out of the column.
      transform: 'none',
      color: vendorLinkColor(theme),
      '&:hover': {
        backgroundColor: theme.palette.mode === 'dark' ? 'rgba(155, 142, 242, 0.18)' : 'rgba(115, 100, 219, 0.12)',
      },
      '& .MuiSvgIcon-root': {
        fontSize: 18,
        transform: 'rotate(-90deg)',
      },
    },
    '& .MuiIconButton-root.RaDatagrid-expandIcon.RaDatagrid-expanded': {
      transform: 'none',
    },
    '& .RaDatagrid-expandHeader .MuiIconButton-root.RaDatagrid-expandIcon': {
      alignItems: 'center',
    },
    '& .RaDatagrid-expandIconCell': {
      verticalAlign: 'top',
    },
    '& .RaDatagrid-expandIconCell .MuiIconButton-root.RaDatagrid-expandIcon': {
      alignItems: 'flex-start',
      paddingTop: '12px',
    },
    '& .RaDatagrid-expandIcon.RaDatagrid-expanded .MuiSvgIcon-root': {
      transform: 'rotate(0deg)',
    },
  };
};

export const GridRowSx: SxProps = {
  mx: -1,
  px: 1,
  py: 0.5,
  borderRadius: 1,
  transition: 'background-color 150ms ease',
  '&:hover': {
    backgroundColor: 'rgba(125, 173, 255, 0.1)',
  },
};

export const LinksCell = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '4px',
});

export const ReportNameContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '5px',
});

export const FieldsTable = styled('div')({
  width: '100%',
  padding: '16px 8px 8px',
});

export const FieldsHead = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'minmax(140px, 28%) 1fr auto',
  alignItems: 'center',
  borderBottom: `1px solid ${theme.palette.divider}`,
}));

export const FieldsHeadCell = styled('span')(({ theme }) => ({
  padding: '4px 12px',
  fontSize: 11,
  fontWeight: 700,
  letterSpacing: '0.06em',
  textTransform: 'uppercase',
  color: theme.palette.text.secondary,
}));

export const FieldsHeadAction = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  paddingRight: 4,
});

export const FieldRow = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'minmax(140px, 28%) 1fr 40px',
  alignItems: 'stretch',
  borderBottom: `1px solid ${theme.palette.divider}`,
  '&:last-of-type': {
    borderBottom: 'none',
  },
}));

const fieldTarget = {
  display: 'block',
  width: '100%',
  margin: 0,
  padding: '10px 12px',
  border: 'none',
  borderRadius: 6,
  background: 'none',
  textAlign: 'left' as const,
  font: 'inherit',
  fontSize: 13,
  lineHeight: 1.4,
  cursor: 'pointer',
  wordBreak: 'break-word' as const,
};

export const FieldLabelButton = styled('button')(({ theme }) => ({
  ...fieldTarget,
  fontWeight: 700,
  color: theme.palette.text.primary,
  '&:hover': {
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(155, 142, 242, 0.18)' : 'rgba(115, 100, 219, 0.12)',
  },
}));

export const FieldValue = styled('button')(({ theme }) => ({
  ...fieldTarget,
  fontWeight: 400,
  color: theme.palette.text.primary,
  '&:hover': {
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(155, 142, 242, 0.18)' : 'rgba(115, 100, 219, 0.12)',
  },
}));
